export const Skeleton = ({ className }: { className?: string }) => <div className={`animate-pulse bg-surface-variant ${className}`} />;